import { ParamsTypes } from './index'

const denormalizer = ({ roomId }: ParamsTypes) => {
  return {
    sessionSn: roomId,
    // 目前 api 邏輯如果是直播主就只會拿到直播主的流，而非後端合成後的流，但需求上直播主或觀眾看到的 playback 都會是一樣，所以目前寫死一個 memberInfoId
    // memberInfoId 10 是每間會固定產生的 guest user
    memberInfoId: 10,
  }
}

export default denormalizer
